import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video_stop",
  "use": "icon-video_stop-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-video_stop\">\n<rect x=\"7\" y=\"7\" width=\"6\" height=\"16\" rx=\"2\" fill=\"white\" />\n<rect x=\"17\" y=\"7\" width=\"6\" height=\"16\" rx=\"2\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol